import React from 'react';
import PropTypes from 'prop-types';
import download from 'downloadjs';
import clsx from 'clsx';
import {DataGrid, GridToolbar} from '@mui/x-data-grid';
import CircularProgress from '@mui/material/CircularProgress';
import CellModal from './CellModal'
import {sendrequest,downrequest,downrequest_pudding,queryrequest_all} from '../services/requestsetting'
import QueryTable from './QueryTableReduced';
import {ResultsTableToolbar} from './ToolBarReduced';

function getTextWidth(longestCellValueDict) {
    /***
     * Create a canvas element in memory to render the
     * longest string in each value of maxCharDict, in
     * order to grab the element width in px. Note we add
     * 50px padding to account for browser rendering differences.
     * @type {{}}
     */
    const maxWidthDict = {}
    const minWidthPx = 150
    Object.keys(longestCellValueDict).forEach(function (key) {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext("2d");
        ctx.font = "16px Arial";

        const width = ctx.measureText(longestCellValueDict[key]).width;
        if (width > minWidthPx) {
            maxWidthDict[key] = width + 50
        } else {
            maxWidthDict[key] = minWidthPx
        }
    });

    return maxWidthDict
}

function sanitizeData(rows, maxWidthDict,permission_list) {
    /***
     * Sanitize data (this probably should be done server-side) rows=[{a: 1, b: {}...},{a: 0, b:{}...}...]
     * Replace empty objects with blank strings
     */
    console.log(rows)
    if (typeof rows !== 'undefined' && rows.length > 0) {
        rows=rows.filter(row=>row.archive_id!=null) //filter to remove the record with no archive_id items
        // the array is defined and has at least one element
        const longestCellDict = {}                                  // max number of characters in each column
        Object.keys(rows[0]).forEach(function (key) {
            longestCellDict[key] = key;                             // start with the key (column header)
        });

        rows.map(function (row, i) {                                // iterate over arr (each element is obj)
            for (const [key, value] of Object.entries(row)) {       // for each value in obj
                if (typeof value === 'object' && value !== null) {  // if the value itself is obj
                    if (Object.keys(value).length === 0) {          // and that obj is emptyselect count(i.affiliation)
                        row[key] = '';                              // set it to blank string
                    }
                }
                // if the length of this cell value is longer than the stored value, replace
                if (typeof value === 'string' || typeof value === 'number') {
                    if(longestCellDict[key]!==undefined){
                        if (longestCellDict[key].length < value.toString().length) {
                        longestCellDict[key] = value.toString()
                        }
                    }
                    
                }
            }
            // calculate whether row is proprietary or not
            // no obs date header so we are going to pass in the archive id here to split instead
            row['isProprietary'] = isInProprietaryPeriod(row['programID'],permission_list, 'OBJECT',row['ProgramID'])
            //row['isProprietary'] = false
            return row
        })
        maxWidthDict = getTextWidth(longestCellDict)
    }
    return {rows, maxWidthDict}
}

const isInProprietaryPeriod = (program_id,permission_list, OBSTYPE = 'OBJECT',programID) => {
    /***
     * Use the archive ID to define whether the proprietary period is in force.
     * If there's any error, assume within the proprietary period.
     * and return true
     */
    // calibration files are not proprietary
    
    // add to check the prgram ID permission
    if(programID!=='' && permission_list.length>0 &&  permission_list.includes(programID)) 
        return false;
    
    try {
        const today = new Date();

        // Regex: obsblk/year/mmdd/...
        const re = /^(?<obsblk>\d+)\/(?<year>\d{4})\/(?<monthday>\d{4})/;
        const match = re.exec(program_id);

        if (!match) throw new Error("Invalid program_id format");

        const { year, monthday } = match.groups;

        // MMDD -> month/day
        const month = parseInt(monthday.slice(0, 2), 10) - 1; // JS months are 0-based
        const day = parseInt(monthday.slice(2, 4), 10);

        const obsDate = new Date(year, month, day);

        console.log("Parsed obsDate:", obsDate.toISOString());

        today.setMonth(today.getMonth() - 18);

        return obsDate >= today;
    } catch (e) {
        // if we can't parse the date, assume proprietary
        console.error("Date parse failed:", e.message);
        return true;
    }
}



const functionerror = () =>{

}

const setcolumns = (rows,maxWidthDict=null) =>{
    let columns = []
    const DefaultColumns =["archive_id",
    "ProgramID",
    "propid",
    "block",
    "success",
    "mean_mjd",
    "time_start_utc",
    "time_end_utc",
    "time_elapsed_seconds",
    "pywifes_version",
    "ACQ",
    "ARC",
    "OBJECT",
    "SKYFLAT",
    "STANDARD",
    "WIRE",
    ] 
    const customHeaders = {
        "propid": "Allocation ID"
    }
    //Object.keys(rows[0]).filter(key => key !== '_id')
        if (typeof rows !== 'undefined') {
            try {
                columns = DefaultColumns.map(item => ({
                    field: item,
                    headerName: customHeaders[item] || item,
                    width:maxWidthDict!==null&&maxWidthDict!==undefined?maxWidthDict[item]:150,
                    minWidth:100,
                    sortable: item.toString() !== 'obscore', //todo remove from all object-type columns
                    filterable: item.toString() !== 'obscore',
                    disableClickEventBubbling: true,
                    renderCell: (params) => (
                        <div className={params.row.isProprietary ? "has-background-danger-light" : ''}>
                            {item === 'success'
                                ? (params.value === true ? 'true' : params.value === false ? 'false' : '')
                                : typeof params.value === "object" && params.value !== null
                                    ? <CellModal value={params.value} title={item.toString()} />
                                    : params.value
                            }
                        </div>
                    ),
                    hide: ['filename', 'isProprietary'].includes(item.toString()),
                    cellClassName: (params) =>
                        clsx({
                            'has-background-danger-light': params.row.isProprietary,
                        }),
                }))
            } catch (e) {
                console.error('error loading colums',e)
            }
        }
    return columns
}

export default class ResultsTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectionModel: [],
            isDownloading: false,
            isReducing: false,
            rows: [],
            columns: setcolumns([]),
            loading: false,
            maxWidthDict: {},
            proprietarySelectedCount: 0,
            rowCount: 0,
            requestparam: {
                uuid: '',
                next: '',
                previous: ''
            },
            page: 0,
            pageSize: 100,
            query_id: this.props.query_id,
            query: null,
            is_open: false,
            is_query_finished: false,
            nextCursors: {},
            intervalRef: React.createRef()
        };

        this.handleDownload = this.handleDownload.bind(this);
        this.handleDownloadpudding = this.handleDownloadpudding.bind(this);
        this.handleSetSelectionModel = this.handleSetSelectionModel.bind(this);
        this.handleSetIsDownloading = this.handleSetIsDownloading.bind(this);
        this.handlesetResult = this.handlesetResult.bind(this);
        this.handlesetpage = this.handlesetpage.bind(this);
        this.responsequery = this.responsequery.bind(this);
        this.querydataquery = this.querydataquery.bind(this);
        this.handleTabHide = this.handleTabHide.bind(this);
        this.query_all_data = this.query_all_data.bind(this);
        this.handleDownloadFiles = this.handleDownloadFiles.bind(this);
    }

    componentDidMount() {
        if (this.props.query_id !== undefined) {
            this.setState({ requestparam: { uuid: this.props.query_id }, loading: true });
            sendrequest({ uuid: this.props.query_id, request: true }, this.querydataquery, functionerror, this.props.user, true);
            sendrequest({ uuid: this.props.query_id }, this.responsequery, functionerror, this.props.user, true);
        } else {
            let resultdata = this.handlesetResult(this.props.data);
            let { rows, maxWidthDict } = sanitizeData(resultdata.results, {}, resultdata.permission_list);
            const columns = setcolumns(rows, maxWidthDict);
            this.setState({ rows: rows, maxWidthDict: maxWidthDict, columns: columns });
        }
    }

    handlesetpage(newPage) {
        if (newPage.page !== this.state.page) {
            let cursorIndex = 0;
            if (newPage.page > 0){
                cursorIndex = newPage.page;
            } else {
                cursorIndex = newPage.page;
            }

            const cursor = cursorIndex >= 0 ? this.state.nextCursors[cursorIndex] : null;

            const updatedRequest = {
                uuid: this.state.query_id,
                limit: this.state.pageSize,
            };

            // Only include 'next' if it's a non-null value
                updatedRequest.next = cursor;

            this.setState({
                page: newPage.page,
                requestparam: updatedRequest,
                loading: true
            }, () => {
                // we will also call this so that the selections get updated when the results update ie. page nav
                sendrequest(updatedRequest, this.responsequery, functionerror, this.props.user, true);
            });
        }
    }

    query_all_data = async () => {
        if (this.state.is_query_finished) return;
        if (this.state.rowCount > this.state.rows.length) {
            try {
                const response = await queryrequest_all(this.state.requestparam,true);
                const data = await response.json();
                if ([200, 202, 304].includes(response.status)) {
                    this.responsequery(data);
                }
            } catch (error) {
                console.error(error);
            }
        } else {
            this.setState({ is_query_finished: true });
        }
    }

    responsequery(data, is_continue = true) {
        const resultdata = this.handlesetResult(data, this.state.page);
        let { rows, maxWidthDict } = sanitizeData(resultdata.results, {}, resultdata.permission_list);

        this.setState({
            rows,
            maxWidthDict,
            columns: this.state.columns.length === 0 ? setcolumns(rows, maxWidthDict) : this.state.columns,
            loading: false
        });
    }

    querydataquery(data) {
        const dataquery = data[0].query;
        if (dataquery.obs_date !== undefined) {
            dataquery['start_date'] = dataquery.obs_date;
            dataquery['end_date'] = dataquery.obs_date;
        }
        const query = { ...this.state.querydata, ...dataquery };
        this.setState({ query: query });
    }

    handlesetResult(data, page) {
    try {
        let rows = JSON.parse(JSON.stringify(data));
        let rowData = rows[0];

        if (!rowData || !rowData.results) {
            return { results: [], permission_list: [] };
        }
        const rowCount = rowData.count || 0;
        const query_id = rowData.uuid || null;
        const nextId = rowData.next?.archive_id || null;
        const previousId = rowData.previous?.archive_id || null;

        this.setState((prevState) => {
            const nextCursors = { ...prevState.nextCursors };

            // Ensure page 0 is always initialized
            if (!nextCursors.hasOwnProperty(0)) {
                nextCursors[0] = null;
            }

            // Always track the next page, even if it’s null
            nextCursors[page + 1] = nextId || null;


            return {
                rowCount,
                query_id,
                nextCursors,
                requestparam: {
                    ...prevState.requestparam,
                    uuid: query_id,
                    next: nextId,
                    previous: previousId
                }
            };
        });
        this.handleSetSelectionModel(this.state.selectionModel);
        return rowData;

    } catch (error) {
        console.error("Error parsing result:", error);
        return { results: [], permission_list: [] };
    }
}

    handleSetSelectionModel(selectionModel) {
        const MAX_SELECTED = 100;
        const selectedArray = Array.from(selectionModel || []);
        const selected = selectedArray.slice(0, MAX_SELECTED);

        const prevSelection = new Set(this.state.selectionModel || []);
        const updatedSelection = new Set(prevSelection);

        // Add any new selections from this page
        selected.forEach(id => updatedSelection.add(id));

        // Remove IDs that were previously selected and are now unselected on this page only
        this.state.rows.forEach(row => {
            const id = row.archive_id;
            const wasPreviouslySelected = prevSelection.has(id);
            const isNowSelected = selected.includes(id);
            if (wasPreviouslySelected && !isNowSelected) {
                updatedSelection.delete(id);
            }
        });

        // Count proprietary selected rows
        let proprietarySelectedCount = 0;
        this.state.rows.forEach(row => {
            if (
                'archive_id' in row &&
                updatedSelection.has(row.archive_id) &&
                row.isProprietary
            ) {
                proprietarySelectedCount += 1;
            }
        });
        this.setState({
            selectionModel: Array.from(updatedSelection).slice(0, MAX_SELECTED),
            proprietarySelectedCount: proprietarySelectedCount,
        });
    }   


    handleSetIsDownloading(isDownloading) {
        this.setState({isDownloading: isDownloading});
    }
    handleTabHide(){
        this.setState({is_open:!this.state.is_open})
    }

    handleDownloadFiles = async (task_id,file_path) =>{
        const res = await downrequest({'task_id':task_id,'file_path':file_path},{'request_param': 'files/'}, {reduced:true});
        const blob = await res.blob();
        // if single file, use that filename! Otherwise assume gzip
        let download_name = 'anu23m_archive_download.tar.gz'
        // if (selected_paths.length === 1) {
        //     download_name = selected_paths[0].split('/')[selected_paths[0].split('/').length-1]
        // }
        download(blob, download_name);
        this.handleSetIsDownloading(false);
    }

    handleDownload = async (combined = true) => {
        /***
         *
         */
        this.handleSetIsDownloading(true)

        // Call the api with set of ids and ask backend to send a list of files. If there
        // are more than 1 file, zip it.
        alert("It will take some time to process the requested files, please do not refresh or close the page ");
        const selected_paths = []
        const archive_ids=[]
        this.state.selectionModel.forEach(element => {
            for (const row of this.state.rows) {
                // don't push if proprietary
                if (row['archive_id'].toString() === element.toString() && !row['isProprietary']) {
                    selected_paths.push(row['filename'])
                    archive_ids.push(row['archive_id'])

                    break;
                }
            }
        });

        const res = await downrequest({'archive_ids':archive_ids}, {reduced:true, combined:combined});
        // const blob = await res.blob();
        if (res.status !== 200) {
            alert("Files cannot been downloaded ");
            this.handleSetIsDownloading(false);
            return;
        } else {
            const json=await res.json();
            if(json.errors.not_download.length===0)
                alert('Your download request is processing, we will notify you when it is completed. ')
            else
                alert('Your download request is processing, we will notify you when it is completed. Some files are proprietary or not be found in server, please contact the observing team to check. Files not downloaded are: '+ json.errors.not_download.toString())
            // check task
            this.state.intervalRef.current = setInterval(async() => {
                const status_res = await downrequest({'task_id':json.task_id},{'request_param':'check_status/'});
                if(status_res.status === 200){
                    const result = await status_res.json();
                    if(result.task_status === 'SUCCESS') {
                        clearInterval(this.state.intervalRef.current);
                        
                        alert('Files are ready to be downloaded now')
                        await this.handleDownloadFiles(json.task_id,result.task_result)
                    }
                }
                
              }, 5000);
        }

    }

    handleDownloadpudding = async () => {
        /***
         * To send request to puddig and get response
         */
        this.setState({isReducing:true})
        const archive_ids=[]
        this.state.selectionModel.forEach(element => {
            for (const row of this.state.rows) {
                // don't push if proprietary
                if (row['archive_id'].toString() === element.toString() && !row['isProprietary']) {
                    archive_ids.push(row['archive_id'])
                    break;
                }
            }
        });
        //telescope is hardcode to aat_archive, will be changed in the future. this is temporary for testing, change it later
        
        const res = await downrequest_pudding({'archive_ids':archive_ids,"username":this.props.user||'bmiszalski',"telescope":'aat_archive'});
        if (res.status !== 200) {
            alert("2dFdr PAWS system offline. Please try again later or contact Data Central");
            this.setState({isReducing:false});
            return;
        } else {
            const json=await res.json();
            try{
                if(json.status==='ok') window.open(json.url, '_blank').focus(); 
                else {
                    alert(json.status_msg);
                }
            }catch{
                alert("Please enbale the pop up window for this tab")
            }
            
            //console.log(json)
            //alert("Files start downloading, you should receive email soon about the detail information");
            this.setState({isReducing:false});
        }
    }

    render() {
        const {selectionModel, isDownloading, rows, columns, proprietarySelectedCount,isReducing} = this.state;
        let link= window.location.href.split('/').slice(0, 3).join('/')
        const resultlink=link+'/results/reduced/'+this.state.query_id
        return (
            <div className="container" >
                    <div className="message">
                        <div className="message-body">
                            <p>An 18 month proprietary period is in force. Data less than 18 months old can only be
                                distributed
                                to a member of the observing team.&nbsp;
                                If you are a member of an observing team, make sure your team has archive access rights to the program in&nbsp; 
                                <a href="https://lens.datacentral.org.au">LENS</a> under the 2.3m Observing System Management section of your proposal.
                            </p>
                            <p>Proprietary rows are downloadable as part of the csv export functionality, but you cannot
                                download the fits files themselves (note that there is no proprietary period for calibration
                                files).
                                Data that is proprietary is marked with a <span className="has-background-danger-light"> red background </span>.
                            </p>
                            <br/>
                            <p>Please note that only the latest successful reduction is available for download.</p>
                            <br/>
                            <p> To access raw data please visit the <b>Query Raw Data</b> page in the toolbar above.</p>
                            <br/>
                            {this.state.query_id!==undefined&& <p>Share this result: <a href={resultlink}> {resultlink}</a></p>}
                        </div>
                    </div>
                <QueryTable
                    is_query={false}
                    initialValues={this.state.query}
                    showResetQuestion={false}
                    is_open={this.state.is_open}
                    handleTabHide={this.handleTabHide}
                />
               
                {columns.length>5 && rows.length>0 &&
                <ResultsTableToolbar selected={selectionModel} 
                    rowNumber={rows.length}
                    handleDownload={this.handleDownload}
                    handleDownloadpudding={this.handleDownloadpudding}
                    user={this.props.user}
                    isReducing={isReducing}
                    isDownloading={isDownloading} 
                    proprietarySelectedCount={proprietarySelectedCount}
                    is_query_finished = {this.state.is_query_finished}
                    rowCount={this.state.rowCount}
                                     />
                }
                <div style={rows.length > 0 ? {height: 800, width: '100%'} : {height: 300, width: '100%'}}>
                {columns.length<5?
                    <CircularProgress size={24} style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                    }}/>
                    :
                   <DataGrid
                        scrollbarSize={1}
                        //rows={this.state.rows[0].results}
                        rows={this.state.rows}
                        getRowId={(row) => row.archive_id}
                        columns={columns}
                        paginationMode='server'
                        paginationModel={{ page: this.state.page, pageSize: this.state.pageSize}}
                        pageSizeOptions={[10, 25, 50, 100]}
                        checkboxSelection
                        selectionModel={this.state.selectionModel}
                        rowCount={this.state.rowCount}
                        loading={this.state.loading}
                        //page={this.state.page}
                        //pageSize={this.state.pageSize}
                        // not working ): onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize })}
                        keepNonExistentRowsSelected={true}
                        onPaginationModelChange={(model) => this.handlesetpage(model)}
                        onRowSelectionModelChange={(newSelection) => {this.handleSetSelectionModel(newSelection.ids)}}
                        components={rows.length > 0 ? {
                            Toolbar: GridToolbar,
                        }: {}} 
                        sx={{
                            "& .MuiDataGrid-virtualScroller": {
                              overflowX: "scroll"
                            },
                            
                          }}        
                    />}
                </div>
            </div>
        );
    }

}


ResultsTableToolbar.propTypes = {
    selected: PropTypes.array.isRequired,
};
